const MeterProvider = {
  0: 'Locus Energy',
  1: 'Also Energy',
};

export default MeterProvider;
